<template>
  <div>
    <div class="title valign-wrapper" v-if="message !== ''">
      <i class="material-icons small red-text">warning</i>{{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  props: {
    message: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {}
}
</script>

<style scoped>
  .title {
    font-size: large;
    font-weight: bold;
    padding: 1rem
  }
  .content {
    padding: 1rem
  }
</style>



// WEBPACK FOOTER //
// src/components/usermanagement/Home.vue